class AlpHelpers  {
  constructor() {}

  static padNumber(theNumber, length) {
    return `${theNumber}`.padStart(length, '0');
  }

  static disableScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    window.onscroll = function() {
        window.scrollTo(scrollLeft, scrollTop);
    };
  }

  static enableScroll() {
    window.onscroll = function() {};
  }

  static debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  static throttle(fn, delay) {
    let lastCall = 0;
    return function (...args) {
      const now = new Date().getTime();
      if (now - lastCall < delay) {
        return;
      }
      lastCall = now;
      return fn(...args);
    };
  }

  static fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }

  static getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  static getSectionInnerHTML(html, selector = '.shopify-section') {
    const element = AlpHelpers.getSectionDOM(html, selector);
    return element ? AlpHelpers.getSectionDOM(html, selector).innerHTML : '';
  }

  static isEmailValid(emailInput) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailInput) {
      return emailRegex.test(emailInput);
    }

    return false;
  }
}
